import { Component, OnInit } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";
import { FormService } from "../services/form.service";

@Component({
	selector: "app-dialog",
	templateUrl: "./dialog.component.html",
	styleUrls: ["./dialog.component.scss"],
})
export class DialogComponent implements OnInit {
	constructor(private formService: FormService, private dialog: MatDialog) {}

	ngOnInit(): void {}

	clearform() {
		this.formService.clearform();
		this.dialog.closeAll();
		this.formService.openSnackBar("削除が完了しました 😇", "close");
	}
}
